export default __webpack_public_path__ + "static/Bildschirmfoto-1-7cc8850c3664805809ecc96dac32aa6f.jpg";